.answerButtons {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 23px;
}
